export enum UserRole {
  RINGER = 'ringer',
  AUCTIONEER = 'auctioneer',
  ADMIN = 'admin'
}

export interface User {
  uid: string;
  email: string;
  displayName: string;
  photoURL?: string;
  
  // Role
  role: UserRole;
  
  // Multi-tenant fields
  primaryAuctionHouse?: string;
  auctionHouseId?: string;
  
  // Subscription
  subscriptionType?: 'free' | 'single_house' | 'network';
  subscriptionTier?: 'free' | 'basic' | 'premium';
  subscriptionStatus?: 'active' | 'canceled' | 'expired' | 'trial';
  subscribedAuctionHouses?: string[];
  
  // Attribution & Marketing
  signupSource?: 'schmidt' | 'auctionringers' | 'direct' | 'referral';
  referralCode?: string;
  affiliateSource?: string;
  
  // Subscription Dates
  subscriptionStartDate?: Date;
  subscriptionEndDate?: Date;
  trialEndsAt?: Date;
  
  // Wallet - Multiple Currencies
  ringerBalances?: {
    [auctionHouseId: string]: number;
  };
  predictionCredits?: number;
  
  // Expert Status
  expertStatus?: 'portal_expert' | 'official_panel' | 'public';
  expertPortals?: string[];
  
  // Stats
  totalPredictions?: number;
  totalWins?: number;
  winRate?: number;
  ringerScore?: number;
  
  // Dates (make optional for backward compatibility)
  createdAt?: Date;
  updatedAt?: Date;
}

// Alias for backward compatibility
export interface UserProfile extends User {
  auctionHouseName?: string;
}

// For admin dashboard
export interface UserWithId extends User {
  id: string;
  auctionHouseName?: string;
}